import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';
import { CheckDiffText } from '../PortManagement/common/utils';
import PortsAltNamesRow from '../PortsAltNames/Row';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changePort } from 'actions/regions/ports';

const styles = {
    dialog: {
        contentStyle: { width: '700px', maxWidth: '90%', padding: '14px' },
    },
    textField: {
        marginBottom: '8px',
    },
    actionButtons: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
    },
};

const INITIAL_DISPLAY_COUNT = 5;

const AltNames = ({
    port, suggestionsPorts, changePort, isForApproval = false, 
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const hasMoreNames = port.alt.length > INITIAL_DISPLAY_COUNT;
    const displayedNames = isExpanded ? port.alt : port.alt.slice(0, INITIAL_DISPLAY_COUNT);

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const updateExternalAltsState = (alts) => {
        changePort({ alt: alts });
    };

    return (
        <Fragment>
            <Dialog
                title="Edit Alternative Names"
                open={isDialogOpen}
                onRequestClose={handleCloseDialog}
                contentStyle={styles.dialog.contentStyle}
                autoScrollBodyContent
            >
                {
                    suggestionsPorts && suggestionsPorts.length ? 
                        <div className='port-suggestions'>
                            <div className='title'>This name has been already used:</div>
                            <div className='content'>
                                {
                                    suggestionsPorts.map(p => (p.alt ? ` ${p.name} - (${p.alt.join(', ')})` : `${p.name}, `))
                                }
                            </div>
                        </div>
                        : null
                }
                <PortsAltNamesRow item={port} updateExternalAltsState={updateExternalAltsState} />
            </Dialog>

            <div className="info__altNames">
                <div className="info__title">
                    <span className="gray">Alternative Names: </span>
                    <IconButton
                        tooltip={isForApproval ? 'Port is not approved yet.' : 'Edit Alternative Names'}
                        onClick={!isForApproval ? handleOpenDialog : () => {}}
                        style={{
                            marginLeft: '25px', padding: '0', width: '24px', height: '24px', 
                        }}
                    >
                        <CreateIcon color='#CBCBCB' viewBox='0 0 30 30' />
                    </IconButton>
                </div>
                {port.alt.length > 0 ? (
                    <div className="alt-names-container">
                        <ul className="alt-names-list">
                            {displayedNames.map((name, index) => (
                                <li key={index}>
                                    <CheckDiffText
                                        oldValue={port.alt[index] || ''}
                                        newValue={name}
                                    />
                                </li>
                            ))}
                        </ul>
                        {hasMoreNames && (
                            <button 
                                className="show-more-button"
                                onClick={() => setIsExpanded(!isExpanded)}
                            >
                                {isExpanded 
                                    ? 'Show less'
                                    : `Show all (${port.alt.length})`
                                }
                            </button>
                        )}
                    </div>
                ) : (
                    <span className="no-alt-names">No alternative names</span>
                )}
            </div>
        </Fragment>
    );
};

AltNames.propTypes = {
    port: PropTypes.shape({
        alt: PropTypes.arrayOf(PropTypes.string),
    }),
};

AltNames.defaultProps = {
    port: {},
};

export default connect(
    state => ({
        port: state.port,
        suggestionsPorts: state.ports.suggestions,
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(AltNames);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/AltNames.jsx